import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import ReportListItem from 'components/ReportListItem';
import IntlMessages from 'util/IntlMessages';

const Duplicates = ({ duplicates, colors, toReport }) => {
	return (
		<Card className="jr-card-full-height">
			<CardHeader className="custom-main">
				<IntlMessages id="meldooWeb.newReport.duplicates.title" />
			</CardHeader>
			<CardBody>
				<ul className="list-unstyled">
					{duplicates.map(report => (
						<ReportListItem key={report.reportId} data={report} toReport={toReport} shortenText={true} shortenTo={3} />
					))}
				</ul>
				{duplicates.length === 0 && (
					<h2 className="text-muted text-center">
						<IntlMessages id="meldooWeb.newReport.duplicates.noDuplicates" />
					</h2>
				)}
			</CardBody>
		</Card>
	);
};

export default Duplicates;



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/NewReport/Component/Duplicates.js